import React, { Component } from "react";
import RequiredRadioGroup from "../common/form/elements/required-radio-group";

export default class MarketingPreferences extends Component {
  options = [
    {
      label: <span>Yes, I want to maximize my ignite experience</span>,
      value: "true",
    },
    {
      label: <div className={`marketing-preferences-label ${window.location.pathname === '/my-profile' ? "marketing-preferences-label-white" : "marketing-preferences-label-black"}`}>No</div>,
      value: "false",
    },
  ];

  optionsConfirm = [
    {
      label: <strong>I've changed my mind, keep me updated</strong>,
      value: "true",
    },
    {
      label: (
        <div className="marketing-preferences-label marketing-preferences-label-white">
          No, I don't want to be kept up to date
        </div>
      ),
      value: "false",
    },
  ];

  render() {
    const { title, type, formData } = this.props;

    return (
      <div className="marketing-preferences">
        {title}
        <div className="preferences--container">
          You must update your contact preferences below so that we are able to
          keep you informed about important news such as legislative
          information, our portfolio updates, pricing changes, and new features.
          <br />
          <br />
          By opting out you may miss out on important updates and reduce the
          potential for maximising your Ignite experience.
        </div>
        <RequiredRadioGroup
          model=".marketing_accepted"
          controlId="marketing_preferences"
          radios={this.options}
          className="preferences--radios"
        />
        {type === "popup" &&
          formData &&
          formData.marketing_accepted === "false" && (
            <div>
              <strong>Are you sure?</strong>
              <br />
              <br />
              <div>
                By no longer receiving <strong>ignite</strong> communications
                you’ll potentially be restricting your maximum earning potential
                and miss out on critical industry and programme information.
              </div>
              <RequiredRadioGroup
                model=".marketing_accepted_confirm"
                controlId="marketing_preferences_confirm"
                radios={this.optionsConfirm}
              />
            </div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about-you/marketing-preferences.jsx